/**
 * Theme Toggle - Dark/Light Mode Switcher
 *
 * Features:
 * - Respects system preference (prefers-color-scheme)
 * - Persists user preference in localStorage
 * - Prevents flash of wrong theme on page load
 * - Accessible toggle button
 */

class ThemeToggle {
  constructor() {
    this.STORAGE_KEY = 'bodywheel-theme';
    this.toggle = document.getElementById('theme-toggle');
    this.init();
  }

  init() {
    this.applyTheme(this.getPreferredTheme());

    if (this.toggle) {
      this.toggle.addEventListener('click', () => this.switchTheme());
    }

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      if (!this.getSavedTheme()) {
        this.applyTheme(e.matches ? 'dark' : 'light');
      }
    });
  }

  getPreferredTheme() {
    const saved = this.getSavedTheme();
    if (saved) return saved;

    // Default to dark mode
    return 'dark';
  }

  getSavedTheme() {
    try {
      return localStorage.getItem(this.STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  saveTheme(theme) {
    try {
      localStorage.setItem(this.STORAGE_KEY, theme);
    } catch (e) {
      // localStorage not available
    }
  }

  applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    this.updateToggleLabel(theme);
  }

  updateToggleLabel(theme) {
    if (this.toggle) {
      const label = theme === 'dark'
        ? 'Switch to light theme'
        : 'Switch to dark theme';
      this.toggle.setAttribute('aria-label', label);
      this.toggle.setAttribute('title', label);
    }
  }

  switchTheme() {
    const current = document.documentElement.getAttribute('data-theme');
    const next = current === 'dark' ? 'light' : 'dark';

    this.applyTheme(next);
    this.saveTheme(next);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ThemeToggle());
} else {
  new ThemeToggle();
}

// Prevent flash of wrong theme - this runs immediately
(function() {
  const STORAGE_KEY = 'bodywheel-theme';
  let theme;

  try {
    theme = localStorage.getItem(STORAGE_KEY);
  } catch (e) {}

  // Default to dark mode if no preference saved
  if (!theme) {
    theme = 'dark';
  }

  document.documentElement.setAttribute('data-theme', theme);
})();
